import { render, staticRenderFns } from "./TariffFactorDetail.vue?vue&type=template&id=75d5162e&"
import script from "./TariffFactorDetail.vue?vue&type=script&lang=js&"
export * from "./TariffFactorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports